<template>
    <div class="wrapper">
        <div class="tit">
            <h1>{{editing ? 'Editar' : 'Nuevo' }} producto</h1>
        </div>
        <div class="ctn_general">

            <div class="tabla_ctn subir_producto">
                <div class="tabla_filtros">
                    <div class="tfiltros_col">
                        <p>Datos del producto</p>
                    </div>
                </div>
                <div class="datos_producto_ctn">
                    <form class="formulario_x2" @submit.prevent="onProcess">
                        <c-input type="text" :field="$v.description" id="description"
                                 classes="grupo_campos tipo_text" label="Descripción *" length="100"/>
                        <c-input type="select" :field="$v.categorySlug" id="category" :items="categories"
                                 classes="grupo_campos tipo_text x2" label="Categoría *"/>
                        <c-input type="select" :field="$v.subcategorySlug" id="subcategory" :items="subcategoriesByCat"
                                 classes="grupo_campos tipo_text x2" label="Subcategoría *"/>
                        <c-input type="text" :field="$v.brand" id="brand" length="100"
                                 classes="grupo_campos tipo_text x2" label="Marca *"/>
                        <c-input type="text" :field="$v.productId" id="productId" length="20"
                                 classes="grupo_campos tipo_text x2" label="Código de producto *"/>
                        <c-input type="text" :field="$v.price" id="price" length="9"
                                 classes="grupo_campos tipo_text x2" label="Precio unitario *"/>
                        <c-input type="text" :field="$v.qtyBase" id="qtyBase" length="20"
                                 classes="grupo_campos tipo_text x2" label="Cantidad base *"/>
                        <c-input type="text" :field="$v.qtyMax" id="qtyMax" length="20"
                                 classes="grupo_campos tipo_text x2" label="Cantidad máxima *"/>
                        <c-input type="text" :field="$v.disc" id="disc" length="10"
                                 classes="grupo_campos tipo_text x2" label="% Descuento (No afecta precio unitario)"/>
                        <c-input type="text" :field="$v.stock" id="stock" length="9"
                                 classes="grupo_campos tipo_text x2" label="Stock *"/>
                        <c-input type="text" :field="$v.unit" id="unit"
                                 classes="grupo_campos tipo_text x2" label="Unidad *" length="10"/>
                        <c-input type="text" :field="$v.unitDesc" id="unitDesc"
                                 classes="grupo_campos tipo_text x2" label="Unidad descripción" length="50"/>
                        <div>
                            <trumbowyg v-model="details" :config="config" class="form-control"
                                       name="content"></trumbowyg>
                        </div>
                        <div class="grupo_campos tipo_checkbox">
                            <h5>Añadir octógonos</h5>
                            <div class="check_group">
                                <div class="checkbox_field">
                                    <input type="checkbox" id="octagono_sodio" v-model="octSod">
                                    <label for="octagono_sodio">Oct. Sodio</label>
                                </div>
                                <div class="checkbox_field">
                                    <input type="checkbox" id="octagono_azucar" v-model="octSugar">
                                    <label for="octagono_azucar">Oct. Azucar</label>
                                </div>
                                <div class="checkbox_field">
                                    <input type="checkbox" id="octagono_sat" v-model="octSat">
                                    <label for="octagono_sat">Oct. Grasas Saturadas</label>
                                </div>
                                <div class="checkbox_field">
                                    <input type="checkbox" id="octagono_trans" v-model="octTrans">
                                    <label for="octagono_trans">Oct. Trans</label>
                                </div>
                            </div>
                        </div>
                        <div class="grupo_campos tipo_checkbox">
                            <h5>Extras</h5>
                            <div class="check_group">
                                <div class="checkbox_field">
                                    <input type="checkbox" id="highlighted" v-model="highlighted">
                                    <label for="highlighted">Enviar en confirmación</label>
                                </div>
                            </div>
                        </div>
                        <div class="grupo_boton">
                            <router-link tag="button" class="btn btn2" :to="{name:'products'}">{{editing ? 'Volver' :
                                'Cancelar'}}
                            </router-link>
                            <button class="btn" type="submit">Guardar</button>
                        </div>
                    </form>
                </div>
            </div>


        </div>
    </div>
</template>
<script>

    import CInput from '../common/CInput.vue'
    import ProductService from "../../services/ProductService";
    import CategoryService from "../../services/CategoryService";
    import Trumbowyg from 'vue-trumbowyg';
    // Import editor css
    import 'trumbowyg/dist/ui/trumbowyg.css';
    import alert from '../../util/alert'
    import {alphaNum, decimal, minValue, required} from 'vuelidate/lib/validators'

    export default {
        props: {
            productIdIn: {
                type: String,
                required: false
            }
        },
        components: {CInput, Trumbowyg},
        data() {
            return {
                categories: [],
                subcategories: [],
                subcategoriesByCat: [],
                editing: false,
                octSod: false,
                octSugar: false,
                octSat: false,
                octTrans: false,
                highlighted: false,
                productId: null,
                description: null,
                categorySlug: null,
                subcategorySlug: null,
                unit: null,
                unitDesc: null,
                brand: null,
                qtyBase: null,
                qtyMax: null,
                disc: null,
                stock: null,
                price: null,
                details: null,
                config: {}
            }
        },
        validations: {
            productId: {required, alphaNum},
            description: {required},
            categorySlug: {required},
            subcategorySlug: {required},
            unit: {required},
            unitDesc: {},
            brand: {},
            qtyBase: {required, decimal, minValue: minValue(0.01)},
            qtyMax: {required, decimal, minValue: minValue(0.01)},
            disc: {decimal, minValue: minValue(0)},
            stock: {required, minValue: minValue(0)},
            price: {required, decimal, minValue: minValue(0.01)},
        }, watch: {
            categorySlug: function () {
                const self = this;
                this.subcategoriesByCat = this.subcategories.filter(it => it.parentKey === self.categorySlug);
                this.subcategorySlug = null;
            },
            productIdIn: function () {
                if (this.productIdIn)
                    this.load(this.productIdIn);
            }
        },
        methods: {
            async load(productId) {
                const self = this;
                try {
                    const response = (await ProductService.getProduct(productId)).data.payload;
                    self.description = response.description;
                    self.categorySlug = response.categorySlug;
                    setTimeout(() => {
                        self.subcategorySlug = response.subcategorySlug;
                    }, 200);
                    self.productId = response.id;
                    self.price = response.price;
                    self.qtyBase = response.qtyBase;
                    self.qtyMax = response.qtyMax;
                    self.disc = response.disc;
                    self.stock = response.stock;
                    self.unit = response.unit;
                    self.brand = response.brand;
                    self.unitDesc = response.unitDesc;
                    self.octSod = response.octSod;
                    self.octSugar = response.octSugar;
                    self.octSat = response.octSat;
                    self.octTrans = response.octTrans;
                    self.highlighted = response.highlighted;
                    self.details = response.details;
                    self.editing = true;
                } catch (e) {
                    alert.error("No se encontró producto");
                }
            },
            async onProcess() {
                const self = this;
                self.$v.$touch();
                if (self.$v.$error) return;

                const data = {
                    description: self.description,
                    categorySlug: self.categorySlug,
                    category: self.categories.find(it => it.key === self.categorySlug).value,
                    subcategorySlug: self.subcategorySlug,
                    subcategory: self.subcategories.find(it => it.key === self.subcategorySlug).value,
                    unit: self.unit,
                    unitDesc: self.unitDesc,
                    brand: self.brand,
                    qtyBase: self.qtyBase,
                    qtyMax: self.qtyMax,
                    disc: self.disc,
                    stock: self.stock,
                    price: self.price,
                    octSat: self.octSat,
                    octSod: self.octSod,
                    octSugar: self.octSugar,
                    octTrans: self.octTrans,
                    highlighted: self.highlighted,
                    details: self.details,
                };
                try {
                    ProductService.save(self.productId, data);
                    self.editing = true;
                    alert.success("Se guardó información de producto correctamente");
                } catch (e) {
                    console.error("Error al guardar producto", e);
                    alert.error("Error al guardar producto");
                }
            },

        },
        async mounted() {
            const self = this;
            self.categories = [];
            self.subcategories = [];
            const response = (await CategoryService.list()).data.payload;
            const sortedCategories = response.sort((a, b) => (a.desc > b.desc) ? 1 : -1);
            sortedCategories.forEach((i) => {
                if (!i.parentKey)
                    self.categories.push({key: i.key, value: i.desc});
                else
                    self.subcategories.push({key: i.key, value: i.desc, parentKey: i.parentKey});
            });
            if (self.productIdIn)
                self.load(self.productIdIn);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/products/ProductEditor.vue